import React  from 'react'
 
const Home = () => {
   
   

 
 
 
   
 
 
  return (
    <div className='mt-0'>
     <div className="flex justify-center  ">
    <div className="flex flex-col justify-center">
      <div className="flex flex-col max-w-7xl justify-center items-center p-2 ">
        <div className="flex flex-col w-[90%] md:w-3/4 text-center items-center justify-center space-y-3">
          <div className=" text-xl font-semibold text-gray-400  ">
         
          The Almighty Allah says in the Holy Quran;  <br></br>
(وَمَآ أُوتِيتُم مِّنَ ٱلۡعِلۡمِ إِلَّا قَلِيلاً۟ )<br></br> 
“And of knowledge, you have been vouchsafed but little.” 
         

          gtreyt
       
          </div>
          <div className=" text-2xl  lg:text-5xl font-bold ">
          Assistant Professor, IoBM, Pakistan
          </div>
          <div className="text-xl font-semibold text-gray-400 ">
            Reseachers
          </div>
          <div className=" text-center text-base ">
          {" "}
          <a
            href="#"
            className="w-8 h-8 inline-block rounded-full pt-[6px]  text-yellow-500 hover:text-blue-500"
          >
            <i className="fa fa-twitter" />
          </a>{" "}
          <a
            href="#"
            className="w-8 h-8 inline-block rounded-full pt-[5px]  text-yellow-500 hover:text-blue-500"
          >
            <i className="fa fa-instagram" />
          </a>{" "}
          <a
            href="https://www.facebook.com/profile.php?id=100067835761988&is_tour_dismissed=true" target="blank"
            className="w-8 h-8 inline-block rounded-full pt-[5px]  text-yellow-500 hover:text-blue-500"
          >
            <i className="fa fa-facebook" />
          </a>{" "}
          <a
            href="https://www.youtube.com/channel/UCRGkU7BCH_caSnWLsj7Svcw" target="blank"
            className="w-8 h-8 inline-block rounded-full pt-[5px] text-yellow-500 hover:text-blue-500"
          >
            <i className="fa fa-youtube" />
          </a>
          <a
            href="https://pk.linkedin.com/in/dr-hira-mujahid-512a164b" target="blank"
            className="w-8 h-8 inline-block rounded-full pt-[5px]  text-yellow-500 hover:text-blue-500"
          >
            <i className="fa fa-linkedin" />
          </a>{" "}
        </div>
        </div>
        {/*  Cv section */}
        <div className='mt-2'>
     
         
<a className='bg-blue-400 px-4 py-2 rounded-md text-black no-underline' href='Hira_Ph.D.pdf' download='Hira_Ph.D.pdf'>Download CV</a>
 
        
  </div>
        <div className="w-3/4 h-60 md:h-96 my-4  rounded-lg overflow-hidden">
          <img
            src="/home_hira.jpeg"
            className="h-full w-full"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
    
    </div>
  )
}

export default Home